import { combineReducers } from 'redux';
import {
  SETTING_CHECKOUT_SET_SETTING,
  FETCH_OUTLETS,
} from 'actions/setting/checkout/constant';
import createReducer from 'utils/createReducer';

const setting = createReducer(
  {},
  {
    [SETTING_CHECKOUT_SET_SETTING]: (draft, { payload }) => payload.data,
  }
);

const outlets = createReducer([], {
  [FETCH_OUTLETS]: (draft, { payload }) => payload.outlets,
});

export default combineReducers({
  setting,
  outlets,
});
